import React, { PureComponent, useEffect, useRef, useState } from 'react';
import { Modal, message } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import Util from '../../../script/util';
import PrettyNum from '../../prettyNum/PrettyNum';
import GiftAtlas from './GiftAtlas';
import { DDLoading } from '../../globalPageStatus';
import { connect } from 'react-redux';
import MedalAtlas from './MedalAtlas';
import PropAtlas from './PropAtlas';
import SuitAtlas from './SuitAtlas';
import { cloneDeep } from 'lodash-es';
import HTTP from '../../../script/service';
import { withRouter } from '../../WithRouterHOC';
import './index.scss';

class AtlasAll extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      atlasData: null, // 礼物，勋章，套系数据
      atlasTab: 2, // 图鉴tab
      suitCarouselIndex: 0, // 套系轮播index
      levelTags: [], // 等级标签列表
    };
  }

  componentDidMount() {
    this.props.dispatch({
      type: 'change_atlas_loading',
      data: { atlasLoading: false },
    });
  }

  // 获取礼物，勋章，套系数据
  getUserSuitWall = () => {
    const { ds } = this.props;
    HTTP._get_user_suit_wall({ searchUid: ds.uid }).then((res) => {
      if (res?.code === 200) {
        this.setState({ visible: true, atlasData: res.data });
      } else {
        message.warning(res?.message || '获取数据失败，请稍后重试');
        this.hideModal();
      }
    });
  };

  // 获取等级列表
  getGiftRarityList = () => {
    HTTP._get_gift_rarity_list().then((res) => {
      if (res?.code === 200) {
        this.setState({ levelTags: res.data });
      } else {
        this.setState({ levelTags: [] });
      }
    });
  };

  // 展示套系弹窗
  showModal = (tab) => {
    this.setState({ visible: true, atlasTab: tab }, () => {
      this.getUserSuitWall();

      this.getGiftRarityList();
    });
  };

  // 隐藏套系弹窗
  hideModal = () => {
    this.setState({ visible: false, suitCarouselIndex: 0 });
  };

  // 切换图鉴tab
  onChangeAtlasTab = (tab) => {
    this.setState({ atlasTab: tab });
  };

  // 套系 tab 轮播切换
  suitChangeCarousel = (index) => {
    this.props.dispatch({
      type: 'change_atlas_loading',
      data: { atlasLoading: true },
    });
    this.setState({ suitCarouselIndex: index });
  };

  // 更新套系轮播列表
  updateCarouselList = (list) => {
    const { atlasData } = this.state;
    atlasData.suitItemList = list;
    this.setState({ atlasData });
  };

  // 修改loading状态
  changeLoading = (loading = false) => {
    this.setState({ loading });
  };

  render() {
    const { base, ds } = this.props;
    const { atlasLoading } = base;
    const { visible, atlasData, atlasTab, suitCarouselIndex, levelTags } =
      this.state;
    return (
      <Modal
        open={visible}
        title={null}
        closable={false}
        wrapClassName="daidai-modal-style has-top-border atlas-all-modal"
        centered
        footer={null}
        width={1130}
        maskClosable={false}
        onCancel={this.hideModal}
      >
        <CloseOutlined className="icon-close" onClick={this.hideModal} />
        <DDLoading status={atlasLoading}>
          {atlasData ? (
            <>
              <div className="atlas-left">
                <div className="user-line">
                  <div className="user-mic-border">
                    <div className="user-avatar">
                      <img
                        src={Util.transImgUrl(ds?.headPic ?? null, '70x70')}
                        alt={ds.nickName}
                      />
                    </div>
                  </div>
                  <div className="user-info">
                    <h3 className="nick-name">{ds.nickName}</h3>
                    <div className="user-account">
                      <PrettyNum
                        uid={ds.uid}
                        num={ds?.beautifulNo}
                        textAlign="left"
                      />
                      <span
                        className="copy-text"
                        onClick={() => Util.copyLink(ds?.beautifulNo || ds.uid)}
                      >
                        {/*复制*/}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="atlas-tab-wrap">
                  <div
                    className={Util.classNames('atlas-gift-tab', {
                      active: atlasTab === 1,
                    })}
                    onClick={() => this.onChangeAtlasTab(1)}
                  >
                    <span className="icon" />
                    <span className="text">礼物图鉴</span>
                    <span className="value">
                      <label>{atlasData.userLightNum}</label>/
                      {atlasData.giftAllNum}
                    </span>
                  </div>
                  <div
                    className={Util.classNames('atlas-prop-tab', {
                      active: atlasTab === 2,
                    })}
                    onClick={() => this.onChangeAtlasTab(2)}
                  >
                    <span className="icon" />
                    <span className="text">道具图鉴</span>
                  </div>
                  <div
                    className={Util.classNames('atlas-medal-tab', {
                      active: atlasTab === 3,
                    })}
                    onClick={() => this.onChangeAtlasTab(3)}
                  >
                    <span className="icon" />
                    <span className="text">勋章墙</span>
                    <span className="value">
                      <label>{atlasData.userMedalCount}</label>/
                      {atlasData.medalCount}
                    </span>
                  </div>
                  <div
                    className={Util.classNames('atlas-suit-tab', {
                      active: atlasTab === 4,
                    })}
                    onClick={() => this.onChangeAtlasTab(4)}
                  >
                    <div className="line">
                      <span className="icon" />
                      <span className="text">套系</span>
                    </div>
                    <div className="suit-carousel-wrap">
                      <SuitTabCarousel
                        atlasLoading={atlasLoading}
                        list={atlasData.suitItemList}
                        index={suitCarouselIndex}
                        isActive={atlasTab === 4}
                        afterChange={this.suitChangeCarousel}
                      />
                    </div>
                    <div className="suit-total">
                      <div className="total-item left">
                        <div className="title">
                          <span className="icon" />
                          套系
                        </div>
                        <div className="value">
                          {atlasData.userLightSuitNum}/{atlasData.suitAllNum}
                        </div>
                      </div>
                      <div className="total-item right">
                        <div className="title">
                          <span className="icon" />
                          套系图鉴
                        </div>
                        <div className="value">
                          {atlasData.userLightSuitGiftNum}/
                          {atlasData.suitGiftAllNum}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="atlas-right">
                {atlasTab === 1 && <GiftAtlas ds={ds} levelTags={levelTags} />}
                {atlasTab === 2 && <PropAtlas ds={ds} levelTags={levelTags} />}
                {atlasTab === 3 && <MedalAtlas ds={ds} />}
                {atlasTab === 4 && (
                  <SuitAtlas
                    ds={ds}
                    index={suitCarouselIndex}
                    onChange={this.suitChangeCarousel}
                    updateCarouselList={this.updateCarouselList}
                  />
                )}
              </div>
            </>
          ) : null}
        </DDLoading>
      </Modal>
    );
  }
}

export default connect((store) => ({ base: store }), null, null, {
  forwardRef: true,
})(withRouter(AtlasAll, { withRef: true }));

// 套系礼物轮播
const SuitTabCarousel = ({
  atlasLoading,
  list,
  index,
  isActive,
  afterChange,
}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const isLoading = useRef(false);
  const [suitList, setSuitList] = useState([]); // 轮播所有的套系列表

  useEffect(() => {
    const copyList = cloneDeep([...(list || [])]);
    for (let i = 0; i < copyList.length; i++) {
      const item = copyList[i];
      if (item.index == null) item.index = i;
      if (item.index < index) {
        item.index = item.index + copyList.length - index;
      } else {
        item.index = item.index - index;
      }
    }
    setSuitList(copyList);
  }, [list, index]);

  // 切换套系轮播
  const onChangeSuitCarouselIndex = (type) => {
    if (atlasLoading) return;
    isLoading.current = true;
    const copySuitList = cloneDeep(suitList);
    const len = copySuitList.length;

    let index = activeIndex - type;
    if (index < 0) index = len - 1;
    if (index >= len) index = 0;
    setActiveIndex(index);
    afterChange(index);

    for (let i = 0; i < len; i++) {
      const oldid = copySuitList[i].index;

      let newId = oldid + 1;
      if (type === 1) {
        newId = oldid + 1 >= len ? 0 : oldid + 1;
      } else if (type === -1) {
        newId = oldid - 1 < 0 ? len - 1 : oldid - 1;
      }
      copySuitList[i].index = newId;
    }
    setSuitList(copySuitList);
  };

  const returnCarouselIndex = (index) => {
    const len = suitList.length;
    let curIndex = index;
    const diff = len - curIndex;
    if (curIndex < 3) {
    } else if (diff < 3) {
      curIndex = 5 - diff;
    } else {
      curIndex = 5;
    }
    return `suit-carousel-item-${curIndex}`;
  };

  return (
    <div className="suit-tab-carousel">
      {isActive && (
        <div
          className="suit-tab-carousel-prev"
          onClick={() => onChangeSuitCarouselIndex(-1)}
        />
      )}
      {suitList.map((item, index) => (
        <div
          key={item.suitId}
          className={Util.classNames(
            'suit-carousel-item',
            item.suitId,
            returnCarouselIndex(item.index)
          )}
        >
          <div className="cover">
            <img src={Util.transImgUrl(item?.suitIcon)} alt={item.suitName} />
          </div>
          {item.index === 0 && (
            <>
              <div className="process">
                <span>
                  {item.suitLightGiftNum}/{item.suitGiftNum}
                </span>
              </div>
              <div className="complete-num">完成：{item?.lightTimes || 0}</div>
            </>
          )}
        </div>
      ))}
      {isActive && (
        <div
          className="suit-tab-carousel-next"
          onClick={() => onChangeSuitCarouselIndex(1)}
        />
      )}
    </div>
  );
};
